import type { RiskRegistry } from '@webapp/risk-core';

/** Tag of the risk whose public quoter URL slug (`meta.slug`) matches, or null. */
export function findRiskTagBySlug(registry: RiskRegistry, slug: string): string | null {
  if (!slug) return null;
  return registry.list().find((plugin) => plugin.meta.slug === slug)?.tag ?? null;
}
